import React, { Fragment } from 'react';
import { Component } from 'react';
import {
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    Stepper,
    Step,
    StepContent,
    StepLabel,
    Paper,
    IconButton,
    Card,
    CardContent,
    InputAdornment,
    Grid,
    useMediaQuery
} from '@mui/material';
import { PhotoCamera, Cancel, Add, Edit } from '@mui/icons-material';
import { Alert } from '@mui/material';
import { 
    postLightPoint, 
    setDeviceLink, 
    postDevice, 
    putDevice, 
    getDeviceType, 
    getRadioNodes, 
    getDevices, 
    getLightPointByID, 
    putLightPoint, 
    removeLightPoint, 
    userCanEdit, 
    getDeviceProfileByUuid, 
    getDevice, 
    DelDeviceOrThingRelation 
} from '../helpers/helper.js';
import SelectComponent from './SelectComponent';
import SelectComponentArchive from './SelectComponentArchive';
import DeleteIcon from '@mui/icons-material/Delete';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { withTranslation } from 'react-i18next';
import { useTheme } from '@mui/styles';
import WebQrScanner from './WebQrScanner.jsx';

class AddLightPointFormDialog extends Component {
    // Costruttore classe
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            coord: {
                lat: null,
                lng: null
            },
            lightpointId: null,
            serialNumber: '',
            originalSerialNumber: '',
            addressCode: 1,
            snMacAddress: '',
            label: '',
            cabinetId: '',
            gatewayId: '',
            lpRadioControllerId: null,
            luminare: null,
            lamp: null,
            support: null,
            driver: null,
            activeStep: 0,
            activeCamera: false,
            resultDevice: '',
            deviceSelected: null,
            originalDeviceSelected: null,
            deviceSelectedType: null,
            buttonCreateObjectDisabled: true,
            radioControllers: []
        }

        // Stepper
        this.steps = [
            "select_cabinet_or_radio",
            "gateway_list",
            "scan_qr_code",
            "settings",
            "summary",
        ]

        // Bind
        this.initDialogState = this.initDialogState.bind(this);
        this.handleScan = this.handleScan.bind(this);
        this.handleError = this.handleError.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handleUpdateCabinetId = this.handleUpdateCabinetId.bind(this);
        this.handleUpdateGatewayId = this.handleUpdateGatewayId.bind(this)
        this.handleChangeLabel = this.handleChangeLabel.bind(this);
        this.sendData = this.sendData.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleChangeLuminare = this.handleChangeLuminare.bind(this);
        this.handleChangeLamp = this.handleChangeLamp.bind(this);
        this.handleChangeSupport = this.handleChangeSupport.bind(this);
        this.handleChangeDriver = this.handleChangeDriver.bind(this);
        this.getStepContent = this.getStepContent.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleCameraClick = this.handleCameraClick.bind(this);
        this.handleCancelSerialNumber = this.handleCancelSerialNumber.bind(this);
        this.handleCancelGateway = this.handleCancelGateway.bind(this);
        this.extractSerialNumber = this.extractSerialNumber.bind(this);
        this.handleChangeSerialNumber = this.handleChangeSerialNumber.bind(this);
        this.searchDevice = this.searchDevice.bind(this);
        this.handleInsertDevice = this.handleInsertDevice.bind(this);
        this.handleUpdateDevice = this.handleUpdateDevice.bind(this);
        this.handleUpdateSelectRadioController = this.handleUpdateSelectRadioController.bind(this);
        this.handleChangeAddressCode = this.handleChangeAddressCode.bind(this);
        this.handleChangeMacAddress = this.handleChangeMacAddress.bind(this);
        this.autoAssignSyraAddressCode = this.autoAssignSyraAddressCode.bind(this);
        this.handleDeviceNotFound = this.handleDeviceNotFound.bind(this);
        this.handleDeviceFound = this.handleDeviceFound.bind(this);
        this.loadLightpointID = this.loadLightpointID.bind(this);
    }

    componentDidMount() {
        this.props.handleDialog(this.handleOpen);
        this.setState({
            originalSerialNumber: this.state.serialNumber,
            originalDeviceSelected: this.state.deviceSelected
        });
    }

    async loadLightpointID() {
        const lightpointId = this.state.lightpointId;
        let deviceData = null
        let deviceGwData = null

        if (lightpointId === null) {
            return;
        }

        const lightpointData = await getLightPointByID(lightpointId)
            .then((responseLp) => {
                return (responseLp && responseLp.data.rows[0]) ? responseLp.data.rows[0] : {};
            })
            .catch((err) => {
                console.error("error", "AddLightpointFormDialog.jsx", "loadLightpointID.getLightpointByID", err);
                return {};
            });    

        if(lightpointData.deviceuuid ){
            const getDeviceRes = await getDevice(lightpointData.deviceuuid)
                .catch((err) => {
                    console.error(err)
                });

            if(getDeviceRes && getDeviceRes.data.rowCount > 0){
                deviceData = {...getDeviceRes.data.rows[0]}
                //Fatto un nuovo getDevice, pero passando adesso il gatewayuuid, cosi prendiamo il correto macAddress

                const getDeviceGwRes = await getDevice(deviceData.gatewayuuid)
                    .catch((err) => {
                        console.error(err)
                    });

                if(getDeviceGwRes && getDeviceGwRes.data.rowCount > 0){
                    deviceGwData = {...getDeviceGwRes.data.rows[0]}
                }
            }
        }

        // Init always to summary
        const canEdit = userCanEdit();

        this.setState({
            lightpointId: lightpointId,
            serialNumber: (deviceData && deviceData.sn)          ? deviceData.sn          : '',
            originalSerialNumber: (deviceData && deviceData.sn)          ? deviceData.sn          : '',
            addressCode:  (deviceData && deviceData.addresscode) ? deviceData.addresscode : '',
            snMacAddress: (deviceGwData && deviceGwData.macaddress)  ? deviceGwData.macaddress  : '',
            label: lightpointData.name ? lightpointData.name : '',
            cabinetId: lightpointData.parententity === "cabinet" ? lightpointData.parentuuid : '',
            gatewayId: (deviceData && deviceData.gatewayuuid)  ? deviceData.gatewayuuid  : '',
            //lpRadioControllerId: null,
            //luminare: lightpointData.luminareArchiveId ? lightpointData.luminareArchiveId : null,
            lamp: lightpointData.lamparchiveuuid ? lightpointData.lamparchiveuuid : null,
            //support: lightpointData.supportArchiveId ? lightpointData.supportArchiveId : null,
            //driver: lightpointData.driverArchiveId ? lightpointData.driverArchiveId : null,
            activeStep: canEdit ? 0 : 3,
            activeCamera: false,
            resultDevice: '',
            deviceSelected: null,
            originalDeviceSelected: this.state.deviceSelected,
            deviceSelectedType: null,
            buttonCreateObjectDisabled: false
        }, () => {
            if (deviceData && deviceData.sn) {
                this.searchDevice(deviceData.sn, this.handleResultDevice);
            }
        });
        
    }

    initDialogState(lightpointId = null) {
        this.setState({
            lightpointId: lightpointId,
            serialNumber: '',
            addressCode: 1,
            snMacAddress: '',
            label: '',
            //cabinetId: null,
            lpRadioControllerId: null,
            luminare: null,
            lamp: null,
            support: null,
            driver: null,
            activeStep: 0,
            activeCamera: false,
            resultDevice: '',
            deviceSelected: null,
            originalDeviceSelected: null,
            deviceSelectedType: null,
            buttonCreateObjectDisabled: true,
            radioControllers: []
        }, async () => await this.loadLightpointID());
    }

    extractSerialNumber = (data) => {
        const { t } = this.props;
        let code = data.split(" ");
        // Controllo del formato del seriale
        if (code.length === 3) {
            return code[1];
        }
        else {
            return t("unknown_format");
        }
    }

    // Gestione stepper
    /**
     * Carica il contenuto dello step selezionato
     * @param {*} step
     */
    getStepContent = (step) => {
        const { t } = this.props;
        const canEdit = userCanEdit();

        switch (step) {
            case 0:
                return (
                    <Paper sx={{ padding: "20px 10px" }}>
                        <SelectComponent
                            inputLabel="Cabinet"
                            id="select-cabinet"
                            disabled={!canEdit}
                            items={this.props.cabinets}
                            onChange={this.handleUpdateCabinetId}
                            value={this.state.cabinetId}
                            required
                        />
                        {
                            (
                                this.state.deviceSelectedType !== null &&
                                this.state.deviceSelectedType.deviceTypeId === 4 &&
                                this.state.radioControllers.length > 0
                            ) &&
                                <SelectComponent
                                    id="select-radiocontroller"
                                    disabled={!canEdit}
                                    items={this.state.radioControllers}
                                    inputLabel={t("radio")}
                                    value={(this.state.lpRadioControllerId !== null) ? this.state.lpRadioControllerId : ''}
                                    onChange={this.handleUpdateSelectRadioController}
                                    style={{ marginTop: "10px" }}
                                />
                        }
                    </Paper>
                );
            
            case 1:
                return (
                    <Paper sx={{ padding: "20px 10px" }}>
                        <SelectComponent
                            inputLabel="Gateway"
                            id="select-gateway"
                            disabled={!canEdit}
                            items={this.props.gateways}
                            onChange={this.handleUpdateGatewayId}
                            value={this.state.gatewayId}
                            endAdornment={
                                canEdit && (
                                    <InputAdornment position="end" style={{ marginRight: "15px"}}>
                                        <IconButton onClick={this.handleCancelGateway}>
                                            <Cancel/>
                                        </IconButton>
                                    </InputAdornment>
                                    )
                                }
                        />
                    </Paper>
                );
            
            case 2:
                return (
                    <Paper sx={{ padding: "10px" }} >
                        <TextField
                            fullWidth
                            disabled={!canEdit}
                            value={this.state.serialNumber}
                            margin="dense"
                            id="snDevice"
                            label={t("serial_number")}
                            type="text"
                            variant="outlined"
                            onChange={this.handleChangeSerialNumber}
                            inputProps={{
                                maxLength: 8
                            }}
                            style={{ marginBottom: "10px" }}
                            InputProps={{
                                endAdornment: canEdit ? (
                                    <InputAdornment position="end">
                                        <IconButton onClick={this.handleCameraClick}>
                                            <PhotoCamera />
                                        </IconButton>
                                        <IconButton onClick={this.handleCancelSerialNumber}>
                                            <Cancel />
                                        </IconButton>
                                    </InputAdornment>
                                ) : null
                            }}
                        />
                        {this.state.activeCamera === true ?
                            <div style={{
                                width: 'calc(100% - 2px)',
                                height: '300px',
                                maxHeight: '300px',
                                border: "1px solid #ccc",
                                borderRadius: "4px"
                            }}>
                                <WebQrScanner
                                    onError={this.handleError}
                                    onResult={this.handleScan}
                                />
                            </div> : null
                        }
                        {this.state.resultDevice}
                    </Paper>
                );
                
            case 3:
                return (
                    <Paper sx={{ padding: "10px" }}>
                        <TextField
                            disabled={!canEdit}
                            value={this.state.label}
                            margin="dense"
                            id="label"
                            label={t("lightpoint_label")}
                            type="text"
                            fullWidth
                            onChange={this.handleChangeLabel}
                            variant="outlined"
                            style={{ marginBottom: "10px" }}
                        />
                        <Typography>{t("registry_components")}</Typography>
                        {/*<SelectComponentArchive
                            disabled={!canEdit}
                            items={this.props.luminaresArchive}
                            inputLabel={t("luminare")}
                            labelConcatProperties={["type", "producer", "model", "optics"]}
                            onChange={this.handleChangeLuminare}
                            variant="outlined"
                            style={{ marginBottom: "10px", marginTop: "10px" }}
                            value={this.state.luminare}
                        />*/}
                        <SelectComponentArchive
                            disabled={!canEdit}
                            items={this.props.lampsArchive}
                            inputLabel={t("lamp")}
                            labelConcatProperties={["producer", "model", "power"]}
                            onChange={this.handleChangeLamp}
                            variant="outlined"
                            style={{ marginBottom: "10px" }}
                            value={this.state.lamp}
                        />
                        {/*<SelectComponentArchive
                            disabled={!canEdit}
                            items={this.props.supportsArchive}
                            inputLabel={t("support")}
                            labelConcatProperties={["type", "meterial", "height"]}
                            onChange={this.handleChangeSupport}
                            variant="outlined"
                            style={{ marginBottom: "10px" }}
                            value={this.state.support}
                        />
                        <SelectComponentArchive
                            disabled={!canEdit}
                            items={this.props.driversArchive}
                            inputLabel={t("driver")}
                            labelConcatProperties={["type", "producer", "model"]}
                            onChange={this.handleChangeDriver}
                            variant="outlined"
                            style={{ marginBottom: "10px" }}
                            value={this.state.driver}
                        />*/}
                    </Paper>
                );
            case 4:
                return (
                    <Card>
                        <CardContent>
                            <Typography color="textSecondary" gutterBottom>{t("lightpoint")}</Typography>
                            <Typography variant="h5" component="h2">{this.state.label}</Typography>
                            <Typography color="textSecondary">{t("device")}: {(this.state.deviceSelectedType !== null) ? this.state.deviceSelectedType.model : t("not_paired")}</Typography>
                            <Typography color="textSecondary">{t("code")}: {(this.state.deviceSelectedType !== null) ? this.state.deviceSelectedType.code : t("not_paired")}</Typography>
                            <Typography color="textSecondary">{t("serial_number")}: {(this.state.deviceSelected !== null) ? this.state.serialNumber : t("not_paired")}</Typography>
                            <Typography color="textSecondary">{t("address_code")}: {(this.state.deviceSelected !== null) ? (this.state.addressCode) : t("not_paired")}</Typography>
                            <Typography color="textSecondary">{t("mac_address")}: {(this.state.deviceSelected !== null) ? this.state.deviceSelected.macaddress : t("not_paired")}</Typography> {/*prima era this.state.deviceSelected.macaddress */}
                        </CardContent>
                    </Card>
                );
            default:
                return 'Unknow step';
        }
    }
    /**
     * Gestione del pulsante stepper Next
     */
    handleNext = () => {
        let nextStep = this.state.activeStep + 1;
        this.setState({
            activeStep: nextStep
        });
        // Sono all'ultimo step?
        if (nextStep === this.steps.length - 1) {
            this.setState({
                buttonCreateObjectDisabled: false
            });
        }
    }
    /**
     * Gestione del pulsante stepper Back
     */
    handleBack = () => {
        this.setState({
            activeStep: this.state.activeStep - 1
        });
        this.setState({
            buttonCreateObjectDisabled: true
        });
    }

    /**
     * Funzione di ricerca device in archivio e controllo del risultato
     * @param {*} sn
     * @param {*} callback
     */
    searchDevice = async (sn, callback) => {
        const { t } = this.props;
        let projectId = localStorage.getItem("currentProjectId");
    
        try {
            // Controlla il tipo di device
            let deviceObj = await getDeviceType(sn);
    
            // Verifica preliminare se il device a um serial correto per un LP
            if (deviceObj.code === "" || (deviceObj.code !== "" && deviceObj.devicetypeid === 2)) {
                callback(<Alert severity="error">{t("device_sn_incompatible")}</Alert>);
                return;
            }
    
            this.setState({ deviceSelectedType: deviceObj });
    
            // Ricerca devices
            const getDevicesRes = await getDevices(sn);
    
            let devInfo = getDeviceType(sn.slice(0, 2));
            if (![1, 3, 4].includes(devInfo.devicetypeid)) {
                this.setState({ deviceSelected: null });
                callback(<Alert severity="error">{t("lightpoint_unsupported_device")}</Alert>);
                return;
            }
    
            if (getDevicesRes.data.rowCount === 0) {
                await this.handleDeviceNotFound(devInfo, callback);
            } else if (getDevicesRes.data.rowCount > 0) {
                await this.handleDeviceFound(getDevicesRes, devInfo, projectId, callback);
            }
        } catch (err) {
            callback(<Alert severity="warning" style={{ marginBottom: "10px" }}>{err.message}</Alert>);
        }
    };
    
    handleDeviceNotFound = async (devInfo, callback) => {
        const { t } = this.props;
        let strInfoDevice = `Device: ${devInfo.model} - Code: ${devInfo.code}`;
        if (devInfo.devicetypeid === 1) {
            strInfoDevice += ` - Address: ${this.state.addressCode}`;
        } else {
            strInfoDevice += " - Address: auto";
        }
    
        callback(
            <Fragment>
                {[1, 3, 4].includes(devInfo.devicetypeid) && (
                    <TextField
                        fullWidth
                        id="addressCode"
                        label={t("address_code")}
                        type="number"
                        variant="outlined"
                        defaultValue={this.state.addressCode}
                        InputProps={{ inputProps: { max: 1000, min: 1 } }}
                        onChange={this.handleChangeAddressCode}
                        style={{ marginBottom: "10px" }}
                    />
                )}
                {[3].includes(devInfo.devicetypeid) && (
                    <TextField
                        fullWidth
                        defaultValue={this.state.snMacAddress}
                        margin="dense"
                        label={t("mac_address")}
                        type="text"
                        variant="outlined"
                        onChange={this.handleChangeMacAddress}
                        style={{ marginBottom: "10px" }}
                    />
                )}
                <Alert severity="info" style={{ marginBottom: "10px" }}>{strInfoDevice}</Alert>
                <Alert severity="warning" style={{ marginBottom: "10px" }}>{t("device_not_found_in_archive")}</Alert>
                <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    startIcon={<Add />}
                    onClick={() => {
                        this.handleInsertDevice({
                            sn: this.state.serialNumber,
                            deviceTypeId: devInfo.devicetypeid,
                            addressCode: parseInt(this.state.addressCode),
                            macAddress: this.state.snMacAddress,
                            projectId: localStorage.getItem("currentProjectId"),
                            deviceprofileuuid: devInfo.uuid
                        }, this.handleResultDevice);
                    }}
                >
                    {t("insert")}
                </Button>
            </Fragment>
        );
    };
    
    handleDeviceFound = async (getDevicesRes, devInfo, projectId, callback) => {
        const { t } = this.props;
    
        if (getDevicesRes.data.rows[0].projectuuid !== projectId) {
            this.setState({
                deviceSelected: null,
                originalDeviceSelected: null
            });
            callback(<Alert severity="error">{t("incompatible_device")}</Alert>);
            return;
        }
    
        let strInfoDevice = `Device: ${devInfo.model} - Code: ${devInfo.code}`;
        this.setState({ addressCode: getDevicesRes.data.rows[0].addresscode });
    
        let DeviceProfileUuid = getDevicesRes.data.rows[0].deviceprofileuuid;
        try {
            const resDeviceProfile = await getDeviceProfileByUuid(DeviceProfileUuid);
            if (resDeviceProfile.data.rows[0].devicetypeid === 1) {
                strInfoDevice += ` - Address: ${getDevicesRes.data.rows[0].addresscode}`;
            } else {
                strInfoDevice += " - Address: auto";
            }
            getDevicesRes.data.rows[0].devicetypeid = resDeviceProfile.data.rows[0].devicetypeid;
        } catch (err) {
            console.error(err);
        }
    
        this.setState({ deviceSelected: getDevicesRes.data.rows[0] }, () => callback(
            <Fragment>
                {[1, 3, 4].includes(getDevicesRes.data.rows[0].devicetypeid) && (
                    <TextField
                        fullWidth
                        id="addressCodeUpdate"
                        label={t("address_code")}
                        type="number"
                        variant="outlined"
                        defaultValue={this.state.addressCode}
                        InputProps={{ inputProps: { max: 1000, min: 1 } }}
                        onChange={this.handleChangeAddressCode}
                        style={{ marginBottom: "10px" }}
                    />
                )}
                {[3].includes(getDevicesRes.data.rows[0].devicetypeid) && (
                    <TextField
                        fullWidth
                        defaultValue={this.state.snMacAddress}
                        margin="dense"
                        label={t("mac_address")}
                        type="text"
                        variant="outlined"
                        onChange={this.handleChangeMacAddress}
                        style={{ marginBottom: "10px" }}
                    />
                )}
                <Alert severity="success" style={{ marginBottom: "10px" }}>{t("device_found")}</Alert>
                <Alert severity="info" style={{ marginBottom: "10px" }}>{strInfoDevice}</Alert>
                {[1, 3, 4].includes(getDevicesRes.data.rows[0].devicetypeid) && (
                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        startIcon={<Edit />}
                        onClick={() => {
                            this.handleUpdateDevice(this.state.deviceSelected.uuid, {
                                addresscode: parseInt(this.state.addressCode),
                                macaddress: this.state.snMacAddress,
                            }, this.handleResultDevice);
                        }}
                    >
                        Modifica
                    </Button>
                )}
            </Fragment>
        ));
    
        if (!this.state.originalDeviceSelected) {
            this.setState({ originalDeviceSelected: getDevicesRes.data.rows[0] });
        }
    
        return getDevicesRes.data.rows[0];
    };
    

    handleCameraClick = () => {
        this.setState({
            activeCamera: !this.state.activeCamera
        });
    }

    handleCancelSerialNumber = () => {
        this.setState({
            serialNumber: '',
            deviceSelected: null,
        });
        this.handleResultDevice('');
    }

    handleCancelGateway = () => {
        this.setState({
            gatewayId: '',
        });
        this.handleResultDevice('');
    }

    /**
     * Gestore delle modifiche al valore del campo serialNumber
     * @param {*} event
     */
    handleChangeSerialNumber = (event) => {
        const inputValue = event.target.value.toUpperCase(); 
        const isValid = /^[A-Za-z]{2}[0-9]{6}$/.test(inputValue) | /^[A-Za-z]{1}[0-9]{7}$/.test(inputValue)  // Verifica se corrisponde al default sn formatt
    
        if (inputValue === "" || inputValue === null ){
            this.setState({
                serialNumber: '',
                deviceSelected: null
            });
        }

        if (isValid) {
            let sn = inputValue;
            //let devInfo = getDeviceType(sn.slice(0, 2));
            let tmpAddressCode = parseInt(sn.slice(-3));
    
            if (tmpAddressCode === 0) {
                tmpAddressCode = 1000;
            }
    
            this.setState({
                serialNumber: sn,
                addressCode: tmpAddressCode,
                //snMacAddress: ([3].includes(devInfo.devicetypeid) ? sn : "")
            });
    
            // Recupera informazioni del device
            this.searchDevice(sn, this.handleResultDevice);
        } else {
            // Se non è valido, non aggiorna lo state e pulisce il result del device
            this.setState({ serialNumber: inputValue });
            this.handleResultDevice('');
            this.setState({ deviceSelectedType: null });
        }
    }

    /**
     * Gestore delle modifiche al valore del campo Address Code
     * @param {*} event
     */
    handleChangeAddressCode = (event) => {
        this.setState({ addressCode: event.target.value });
    }

    /**
     * Gestore visualizzazione del risultato della ricerca dispositivo
     * @param {*} result
     */
    handleResultDevice = (result) => {
        this.setState({
            resultDevice: result
        })
    }

    /**
     * Gestore per l'inserimento di un nuovo device
     * @param {*} model
     * @param {*} callback
     */
    handleInsertDevice = (model, callback) => {
        const { t } = this.props;
        postDevice(model)
            .then((res) => {
                this.setState({
                    deviceSelected: {...res.data.rows[0], 'macaddress': model.macAddress}
                });
                callback(<Alert severity="success">{t("device_insert_ok")}</Alert>);
            })
            .catch((err) => {
                console.error(err);
                this.setState({
                    deviceSelected: null
                });
                callback(<Alert severity="error">{t("device_insert_err")}</Alert>);
            })
    }

    /**
     * Gestore per l'aggiornamento del Device
     * @param {*} model
     * @param {*} callback
     */
    handleUpdateDevice = (deviceId, model, callback) => {
        const { t } = this.props;
        putDevice(deviceId, model)      
            .then((res) => {
                this.setState({
                    deviceSelected: res.data.rows[0]
                });
                callback(<Alert severity="success">{t("device_update_ok")}</Alert>);
            })
            .catch((err) => {
                console.error(err);
                this.setState({
                    deviceSelected: null
                });
                callback(<Alert severity="error">{t("device_update_err")}</Alert>);
            })
    }

    handleScan = (data) => {
        // Check data
        if (data) {
            // Estrae il seriale dall'immagine
            let snDevice = this.extractSerialNumber(data);

            // Imposta il valore del seriale
            this.setState({ serialNumber: snDevice });

            // Chiude la schermata della camera
            this.setState({
                activeCamera: false
            });

            // Recupera informazioni sul device
            this.searchDevice(snDevice, this.handleResultDevice);
        }
    }

    handleError = (err) => {
        console.error(err)
    }

    handleUpdateCabinetId = (val) => {
        this.setState({ cabinetId: val });
        // Filtro dei radio controller disponibili
        let rcList = this.props.lightPoints.filter((lp) => {
            return (lp.device && lp.device.deviceTypeId === 3 && lp.cabinetId === val);
        });
        // Aggiorno lo stato dei concentratori disponibili
        this.setState({
            radioControllers: rcList
        });
    }

    handleUpdateGatewayId = (val) => {
    
        this.setState({ gatewayId: val }, () => {
            // Il getDevice sara chiamato dopo di che il gatewayId è setatto, cosi non abbiamo problemi con settagio contemporaneo di props
            getDevice(val)
                .then((res) => {
                    const macAddressVal = res.data.rows[0].macaddress;

                    // Aggiorna lo state di deviceSelected corretament
                    this.setState({ snMacAddress: macAddressVal });
                })
                .catch((err) => {
                    console.error(err);
                });
        });

    }

    handleUpdateSelectRadioController = (val) => {
        this.setState({
            lpRadioControllerId: val
        }, function () {
            // Eseguo ricerca del primo addressCode libero per il nodo
            this.autoAssignSyraAddressCode();
        });
    }

    handleChangeLabel = (event) => {
        this.setState({ label: event.target.value });
        //setLabel(event.target.value);
    }

    handleChangeLuminare = (val) => {
        this.setState({ luminare: val });
    }
    handleChangeLamp = (val) => {
        this.setState({ lamp: val });
    }
    handleChangeSupport = (val) => {
        this.setState({ support: val });
    }
    handleChangeDriver = (val) => {
        this.setState({ driver: val });
    }

    handleChangeMacAddress = (event) => {
        this.setState({ snMacAddress: event.target.value });
    }

    autoAssignSyraAddressCode = async () => {
        let lpRadioControllerObj = this.props.lightPoints.find((lp) => { return lp.uuid === this.state.lpRadioControllerId });
        //lightPointObj.radioControllerId = lpRadioControllerObj.radioController.id

        // Si deve assegnare un codice valido al nodo
        // Lettura dei nodi configurati nel concentratore
        await getRadioNodes({ "filter": { "where": { "radioControllerId": lpRadioControllerObj.radioController.id } } })
            .then((res) => {
                // Ricerca di un codice libero tra 3585 - 3744
                for (let code = 3586; code < 3744; code++) {
                    if (res.data.find((rn) => { return rn.configuration.syraCode === code }) === undefined) {

                        // Aggiornamento del modello Device
                        putDevice(this.state.serialNumber, { "addresscode": code })     
                            .then((res) => {
                                this.setState({ addressCode: (code) });
                                let deviceSelected = { ...this.state.deviceSelected }
                                deviceSelected.addressCode = code;
                                this.setState({ deviceSelected });
                            })
                            .catch((err) => {
                                console.error(err);
                            });
                        break;
                    }
                }
            })
            .catch((err) => {
                console.error(err);
            });
    }

    sendData = async () => {
        const projectId = localStorage.getItem("currentProjectId");
        const bodyPayload = {
            "name": this.state.label,
            "geometry":[ 
                this.state.lng,
                this.state.lat
            ],
            "projectuuid": projectId
        }

        // Distingue se è stato selezionato un radio controller come padre
        if (this.state.lpRadioControllerId !== null) {
            let lpRadioControllerObj = this.props.lightPoints.find((lp) => { return lp.id === this.state.lpRadioControllerId });
            bodyPayload.radioControllerId = lpRadioControllerObj.radioController.id
        }
        else {
            //bodyPayload.cabinetId = this.state.cabinetId;
            bodyPayload.parententity = 'cabinet';
            bodyPayload.parentuuid = this.state.cabinetId;
        }

        // Invia i dati
        /*if (this.state.luminare != null) {
            bodyPayload.luminareArchiveId = this.state.luminare;
        }*/
        if (this.state.lamp != null) {
            //bodyPayload.lampArchiveId = this.state.lamp;
            bodyPayload.lamparchiveuuid = this.state.lamp;
        }
        /*if (this.state.support != null) {
            bodyPayload.supportArchiveId = this.state.support;
        }
        if (this.state.driver != null) {
            bodyPayload.driverArchiveId = this.state.driver;
        }*/

        postLightPoint(bodyPayload)
            .then(res => {
                this.handleClose();
                // Se valorizzato anche il campo serialNumber
                // Controlla il formato del codice ed esegue l'abbinamento
                if (this.state.serialNumber && this.state.serialNumber !== '') {
                        // Eseguo l'abbinamento del cabinet creato con il relativo device
                        const thingentity = "lightpoint"
                        setDeviceLink(this.state.deviceSelected.uuid, thingentity, res.data.rows[0].uuid)
                            .catch((err) => {
                                console.error(err);
                            });
                        
                        //Verifica se il deviceSelected.GATEWAYUUID è diverso dal gatewayId che abbiamo scelto nel select, se diverso esegue la put
                        if(this.state.deviceSelected.gatewayuuid !== this.state.gatewayId){
                            putDevice(this.state.deviceSelected.uuid, {"gatewayuuid": this.state.gatewayId})
                                .then((resPutDev) => {
                                })
                                .catch((err) => {
                                    console.error(err)
                                })
                        }
                    }

                let newBodyPayload = {
                    parententity: 'cabinet',
                    parentuuid: bodyPayload.parentuuid,
                    geometry: bodyPayload.geometry,
                    lamparchiveuuid: bodyPayload.lamparchiveuuid,
                    name: bodyPayload.name,  
                    projectuuid: bodyPayload.projectuuid,
                    uuid: res.data.rows[0].uuid
                }
                // Inserire il marker nella mappa
                this.props.handleAddLightPoint(newBodyPayload);
            })
            .catch((err) => {
                console.error(err)
            })
    }

    sendEditData = async () => {
        const bodyPayload = {
            "name": this.state.label,
            "geometry": [
                this.state.lng,
                this.state.lat
            ]
        };
    
        if (this.state.lpRadioControllerId !== null) {
            const lpRadioControllerObj = this.props.lightPoints.find(lp => lp.uuid === this.state.lpRadioControllerId);
            bodyPayload.radioControllerId = lpRadioControllerObj.radioController.id;
        } else {
            bodyPayload.parententity = 'cabinet';
            bodyPayload.parentuuid = this.state.cabinetId;
        }
    
        if (this.state.lamp != null) {
            bodyPayload.lamparchiveuuid = this.state.lamp;
        }

        if(this.state.deviceSelected && this.state.deviceSelected.gatewayuuid !== this.state.gatewayId ) {

            const bodyPayloadDevice = {
                "gatewayuuid": (this.state.gatewayId && this.state.gatewayId !== "" ) ? this.state.gatewayId : null
            }
    
            await putDevice(this.state.deviceSelected.uuid, bodyPayloadDevice)
                .then((resPutDev) => {
                })
                .catch((err) => {
                    console.error(err)
                })
        }

        //TODO: FAZER CASO TROQUE O GW NO SELECT

    
        putLightPoint(this.state.lightpointId, bodyPayload)
            .then(async res => {
                this.handleClose();
                await this.handleSerialNumberUpdate(res.data.rows[0].uuid);
                this.props.handlePutLightpoint(res.data.rows);
            })
            .catch(err => {
                console.error(err);
            });
    };
    
    handleSerialNumberUpdate = async (lightPointUuid) => {
        if (this.state.originalSerialNumber && (this.state.serialNumber === "" || this.state.serialNumber === null || this.state.originalSerialNumber !== this.state.serialNumber ) ) {
            await this.removeDeviceRelation(this.state.originalDeviceSelected.uuid, this.state.lightpointId);
        }
    
        if (this.state.serialNumber && this.state.serialNumber !== this.state.originalSerialNumber) {

            await this.linkDeviceWithLightPoint(this.state.deviceSelected.uuid, "lightpoint", lightPointUuid);

            //Verifica se il deviceSelected.GATEWAYUUID è diverso dal gatewayId che abbiamo scelto nel select, se diverso esegue la put
            if(this.state.deviceSelected.gatewayuuid !== this.state.gatewayId){
                await this.updateDevice(this.state.deviceSelected.uuid, {"gatewayuuid": this.state.gatewayId})
            }
            
        }
    };
    
    removeDeviceRelation = (deviceUuid, lightPointId) => {
        return DelDeviceOrThingRelation(deviceUuid, lightPointId) 
            .then((resDel) => {
            })
            .catch(err => {
                console.error(err);
                throw err;
            });
    };
    
    updateDevice = (deviceUuid, payload) => {
        return putDevice(deviceUuid, payload)
            .then((resPut) => {
            })
            .catch(err => {
                console.error(err);
                throw err;
            });
    };
    
    linkDeviceWithLightPoint = (deviceSelectedUuid, deviceEntity, lightPointUuid) => {
        setDeviceLink(deviceSelectedUuid, deviceEntity, lightPointUuid)
            .then((linkRes) => {
            })
            .catch(err => {
                console.error(err);
                throw err;
            });
    };

    /**
     * Gestore per la rimozione di un cabinato
     * @param {*} newLightPoint
     */
    async sendRemoveData() {
        
        if (this.state.serialNumber && this.state.serialNumber !== '') {
            await DelDeviceOrThingRelation(this.state.deviceSelected.uuid, this.state.lightpointId)
                .catch((err) => {
                    console.error(err);
                });
        }

        await removeLightPoint(this.state.lightpointId)
            .then( res => {
                this.handleClose();
                // Inserire il marker nella mappa
                this.props.handleDelLightpoint({ ...res.data.rows[0], uuid: this.state.lightpointId });
            })
            .catch((err) => {
                console.error(err)
            })
    }

    handleClose = () => {
        this.setState({
            open: false,
            activeStep: 0
        });
        //setOpen(false);
    };

    handleOpen = (entity) => {
        if(!entity.lightpointId){
            this.setState({ open: true, lat: entity.lat, lng: entity.lng, gatewayId: '', cabinetId: '' })
            this.initDialogState(entity.lightpointId);
        } else {
            this.setState({ open: true, lat: entity.lat, lng: entity.lng})
            this.initDialogState(entity.lightpointId);
        }
    }

    render() {
        const { t } = this.props;
        const isEdit = (this.state.lightpointId !== null);
        const canEdit = userCanEdit();

        return (
            <Dialog
                fullScreen={this.props.isDesktop}
                open={this.state.open}
                onClose={this.handleClose}
                aria-labelledby="form-dialog-title">{
                canEdit && isEdit && this.state.delete ? (
                    <Fragment>
                        <DialogTitle id="form-dialog-title">{t("remove_lightpoint")}</DialogTitle>
                        <DialogContent>
                            <div style={{ textAlign: "center", padding: "40px 10%" }}>
                                <WarningAmberIcon sx={{ fontSize: "3em" }} />
                                <Typography variant="h6">
                                    {t("remove_msg_alert")}
                                </Typography>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Grid container spacing={2} columns={2}>
                                <Grid item xs={1} style={{ textAlign: "left" }}>
                                    <span>&nbsp;</span>
                                </Grid>
                                <Grid item xs={1} style={{ textAlign: "right" }}>
                                    <Button onClick={() => this.setState({ delete: false })}>
                                        {t("cancel")}
                                    </Button>
                                    <Button onClick={() => this.sendRemoveData()}>
                                        {t("delete")}
                                    </Button>
                                </Grid>
                            </Grid>
                        </DialogActions>
                    </Fragment>
                ) : (
                    <Fragment>
                        <DialogTitle id="form-dialog-title">{
                            canEdit ? (
                                isEdit ?
                                    t("edit_lightpoint") :
                                    t("add_lightpoint")
                            ) : t("details_lightpoint")}</DialogTitle>
                        <DialogContent>
                            <Stepper
                                activeStep={this.state.activeStep}
                                orientation="vertical"
                                sx={{
                                    minWidth: {
                                        xs: '100%',
                                        sm: '100%',
                                        md: '480px',
                                        lg: '480px',
                                        xl: '480px'
                                    }
                                }}>
                                {this.steps.map((label, index) => (
                                    <Step key={label}>
                                        <StepLabel>{t(label)}</StepLabel>
                                        <StepContent>
                                            <div>{this.getStepContent(index)}</div>
                                            <div>
                                                <div style={{ marginTop: "10px" }}>
                                                    <Button disabled={this.state.activeStep === 0} onClick={this.handleBack}>
                                                        {t("back")}
                                                    </Button>
                                                    {
                                                        ((this.state.activeStep < this.steps.length - 1 ) || (this.state.activeStep === 1 && this.state.cabinetId !== null)) ?
                                                            <Button disabled={this.state.cabinetId === '' || this.state.cabinetId === null} onClick={this.handleNext}>{t("next")}</Button> : ''
                                                    }
                                                </div>
                                            </div>
                                        </StepContent>
                                    </Step>
                                ))}
                            </Stepper>
                        </DialogContent>
                        <DialogActions>
                            <Grid container spacing={2} columns={2}>
                                <Grid item xs={1} style={{ textAlign: "left" }}>
                                    {canEdit && isEdit ?
                                        <Button color="error" onClick={() => this.setState({ delete: true })} startIcon={<DeleteIcon />}>
                                            {t("delete")}
                                        </Button>
                                    : <span>&nbsp;</span>}
                                </Grid>
                                <Grid item xs={1} style={{ textAlign: "right" }}>
                                    {canEdit ? (
                                        <Fragment>
                                            <Button onClick={this.handleClose}>
                                                {t("cancel")}
                                            </Button>
                                            <Button
                                                disabled={this.state.buttonCreateObjectDisabled}
                                                onClick={() => isEdit ? this.sendEditData() : this.sendData()} >
                                                {t("confirm")}
                                            </Button>
                                        </Fragment>
                                    ) : (
                                        <Button onClick={this.handleClose}>
                                            {t("Close")}
                                        </Button>
                                    )}
                                </Grid>
                            </Grid>
                        </DialogActions>
                    </Fragment>
                )
            }</Dialog>
        );
    }
}

function AddLightPointForm(props) {
    // Get flag desktop
    const isDesktop = useMediaQuery(useTheme().breakpoints.down('md'));
    // Inject media query + i18n
    return (
        <AddLightPointFormDialog
            {...props}
            isDesktop={isDesktop}
        />
    );
}

export default withTranslation()(AddLightPointForm);
